import React, { useEffect, useRef, useState } from 'react';

import styled from '@emotion/styled'

const ToastWrapper = styled.article`
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 25px;
    left: 0;
    width: 100%;
    height: auto;
    opacity: 0;
    transition: opacity 0.5s ease-in-out;
    > div {
        padding: 12.75px 25px;
        border-radius: 999999px;
        color: #ffffff;
        background-color: rgba(0,0,0,.75);
        border: 1px solid rgba(0,0,0,1);
        backdrop-filter: blur(10px);
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);
        font-size: 15px;
    }
`

const Toast = ({ message, duration = 3000}) => {
    const [showToast, setShowToast] = useState(true);
  let toastRef = useRef(null)

  useEffect(() => {

    const fadeInAnimation = () => {
        if(toastRef.current){
            toastRef.current.style.opacity = '1';
        }
        
    };

    const fadeOutAnimation = () => {
        if(toastRef.current.style){
            toastRef.current.style.opacity = '0';
        }
        setTimeout(() => {
            setShowToast(false);
        }, 500);
    };
    fadeInAnimation();

    const timer = setTimeout(() => {
        fadeOutAnimation();
    }, duration);

    return () => {
        clearTimeout(timer);
    };
    


  }, [duration]);

    return (
        <>
        
            {
                showToast?
                <ToastWrapper
                    id="toast"
                    ref={toastRef}
                >
                    <div aria-live="polite">
                        {message}
                    </div>
                </ToastWrapper>
                :null
            }
        </>
    );
  
};

export default Toast;
